//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import unity from "@/unity/unity";
const moment = require('moment-timezone');
export default {
    name: "NewAdvance",
    data() {
        return {
            dialogAdd: false,
            dialogSendMail: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            check_status_tranning: false,
            check_after: false,
            check_time: 0,
            training_name: "",
            date_training: "",
            time_training: "",
            dataitem: {},
            check_check_in: true,
            check_check_out: true,
            time_in: "",
            time_out: "",
            update_id: 0
        };
    },
    components: {
        SuccessDialog,
        SuccessDialogPush,
    },
    computed: {
    },

    watch: {},

    async mounted() {
        const userId = localStorage.getItem(server.USER_ID);
        if (userId && api.isLoggedIn()) {
            // this.$router.push("/");
        } else {
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        }
        await this.loadData()
        await this.loadDataActivity()
        this.$hideLoader();
    },
    methods: {

        async loadData(){
            const res_data = await api.getTRANNING_HByIdSQL(this.$route.params.tranning_id)
            console.log("res_data.data")
            console.log(res_data.data)
            if(res_data.data.length > 0){
                this.check_status_tranning = true;
                this.dataitem = res_data.data[0];
                
                var today = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
                // var today = "2024-05-02 13:00:00";
                
                let dateTime = new Date(res_data.data[0].date_training_start);
                
                // ลบเวลา 1 ชั่วโมง (60 นาที)
                dateTime.setHours(dateTime.getHours() - 1);
                
                // แปลงกลับเป็น string ในรูปแบบที่ต้องการ (YYYY-MM-DD HH:mm:ss)
                var check_start =  moment(dateTime).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
                console.log(check_start);

                if(res_data.data[0].date_training_end < today){
                    this.check_time = 1;
                    return;
                }else if(today < check_start){
                    this.check_time = 2;
                    return
                }else{
                    this.training_name = res_data.data[0].tranning_name;
                    this.date_training = res_data.data[0].date_training;
                    this.time_training = res_data.data[0].time_training;
                }

            }
        },
        async loadDataActivity(){
            const res_act = await api.getTRANNING_HByIdAC(localStorage.getItem(server.USER_ID),this.dataitem.jobtitle_id);
            console.log("res_act.data")
            console.log(res_act.data)
            if(res_act.data.length > 0){
                if(res_act.data[0].isCheckedOut == 0){
                    //update activity
                    this.update_id = res_act.data[0].id
                    this.check_check_in = true;
                    this.check_check_out = false;
                    this.time_in  = res_act.data[0].time_in;
                }else{
                    //crate activity
                    this.check_check_in = true;
                    this.check_check_out = true;
                    this.time_in  = res_act.data[0].time_in;
                    this.time_out  = res_act.data[0].time_out;
                }

            }else{
                 //crate activity first
                 this.check_check_in = false;
            }
        },

        async check_in_ac(){
            
            this.$showLoader()
            let dataAdd = {
                caseType: null,
                chargeType: "OFF",
                images: "",
                company_id: this.dataitem.company_id,
                isCheckedOut: 0,
                userId: localStorage.getItem(server.USER_ID),
                departmentId: this.dataitem.department_id,
                jobTitleId: this.dataitem.jobtitle_id,
                customerId: 0,
                duration: 0,
                addby: "W",
                prospect: "",
                detail: "training",
                status: "A",
                createdAt: localStorage.getItem(server.USER_ID),
                checkInDate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                checkOutDate: "",
            }
            this.time_in = moment().tz('Asia/Bangkok').format('HH:mm')
            console.log("dataAdd")
            console.log(dataAdd)
            console.log(this.time_in)

            const res_add_act = await api.createActivity(dataAdd);
            if (res_add_act.status == 200 || res_add_act.status == 201) {
                await this.loadData()
                await this.loadDataActivity()

                this.$hideLoader()
                this.$store.state.global_push_dialog = true;
                this.setupAlertDialog(
                true,
                "Check In Success",
                `You have checked in at ${this.time_in}.`,
                "text-h5 green--text text-center",
                );
            } else {
                this.$hideLoader()
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                true,
                "Information Saved",
                "ไม่สามารถบันทึกได้!!!",
                "text-h5 red--text text-center"
                );
            }
        },
        
        async check_out_ac(){
            this.$showLoader()
            let data_update = {
                isCheckedOut: 1,
                duration: 0,
                checkOutDate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
            }

            const time_out_v = moment().tz('Asia/Bangkok').format('HH:mm');
            const [startHour, startMinute] = this.time_in.split(':').map(Number);
            const [endHour, endMinute] = time_out_v.split(':').map(Number);

            const startTotalMinutes = startHour * 60 + startMinute;
            const endTotalMinutes = endHour * 60 + endMinute;


            const timeDifferenceInMinutes = endTotalMinutes - startTotalMinutes;

            
            data_update.duration = timeDifferenceInMinutes;

            const res_update = await api.updateDatat_ACT(this.update_id,data_update)

            if (res_update.status == 200 || res_update.status == 201) {
                await this.loadData()
                await this.loadDataActivity()

                this.$hideLoader()
                this.$store.state.global_push_dialog = true;
                this.setupAlertDialog(
                true,
                "Check Out Success",
                `You have Successfully checked out`,
                "text-h5 green--text text-center",
                );
            } else {
                this.$hideLoader()
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                true,
                "Information Saved",
                "ไม่สามารถบันทึกได้!!!",
                "text-h5 red--text text-center"
                );
            }
        },

        setupAlertDialog(status, title, message, text_color) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
        },
        setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
        },
    },
    async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = false;
    },
};
